import { render, staticRenderFns } from "./MBTIAction.vue?vue&type=template&id=38f2d8c6&scoped=true"
import script from "./MBTIAction.vue?vue&type=script&lang=js"
export * from "./MBTIAction.vue?vue&type=script&lang=js"
import style0 from "./MBTIAction.vue?vue&type=style&index=0&id=38f2d8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2d8c6",
  null
  
)

export default component.exports